import { http } from '@noor/api';
import { env } from '@noor/config';

/**
 * Fetch a road-snapped route polyline from the self-hosted OpenRouteService
 * (cpanel uses `routing.noor.uz/ors`). Input/output coordinates are `[long, lat]`.
 * Returns null when no route service is configured or the request fails.
 *
 * Goes through the shared `http` client (per-request `baseURL`) so the
 * `X-Platform: web` marker and auth travel with the routing call like every
 * other backend request — a bare `ofetch` would bypass those interceptors.
 */
export async function fetchRoutePolyline(
  coordinates: [number, number][],
): Promise<[number, number][] | null> {
  const baseUrl = env.VITE_ROUTE_API_URL;
  if (!baseUrl || coordinates.length < 2) return null;

  try {
    const res = await http.post<{
      features?: { geometry?: { coordinates?: [number, number][] } }[];
    }>(
      '/ors/v2/directions/driving-car/geojson',
      { coordinates, language: 'en', units: 'm', preference: 'recommended' },
      {
        baseURL: baseUrl,
        retry: 1,
        headers: { Accept: 'application/geo+json' },
      },
    );
    const coords = res.features?.[0]?.geometry?.coordinates;
    return coords ?? null;
  } catch {
    return null;
  }
}
